import { configureStore, createAction } from '@reduxjs/toolkit';
import companiesReducer from './slices/companies/companiesSlice';
import categoriesReducer from './slices/categories/categoriesSlice';
import userReducer from './slices/user/userSlice';
import documentsReducer from './slices/documents/documentsSlice';
import userSigningInfoReducer from './slices/user-signing-info/userSigningInfoSlice';
import documentContractsReducer from './slices/document-contracts/documentContractsSlice';
import documentTemplatesReducer from './slices/document-templates/documentTemplatesSlice';
import employeesReducer from './slices/employees/employeesSlice';
import suppliersReducer from './slices/suppliers/suppliersSlice';
import customersReducer from './slices/customers/customersSlice';
import todoReducer from './slices/todo/todoSlice';
import businessProfileSlice from './slices/business-profile/businessProfileSlice';
import disclaimerSlice from './slices/disclaimer/disclaimerSlice';
import countriesSlice from './slices/countries/countriesSlice';
import documentUploadHTMLSlice from './slices/document-upload-html/documentUploadHTMLSlice';
import currentDocumentAISummarySlice from './slices/current-document-ai-summary/currentDocumentAISummarySlice';
import showPlanUpgradingMessageSlice from './slices/show-plan-upgrading-message/showPlanUpgradingMessage';
import showProgressOverlaySlice from './slices/show-progress-overlay/showProgressOverlay';
import templatesSlice from './slices/templates/templatesSlice';
import documentsAnotherUserSlice from './slices/documents-another-user/documentsAnotherSlice';
import documentContractsAnotherUserSlice from './slices/document-contracts-another-user/documentContractsAnotherUserSlice';
import supplierBankDetailsReducer from './slices/supplier-bank-details/supplierBankDetails';
import tasksSlice from './slices/tasks/tasksSlice';
import templatePlaceholdersIdsSlice from './slices/templatePlaceholdersIds/templatePlaceholdersIds';
import templatePlaceholdersIndexesSlice from './slices/templatePlaceholdersIndexes/templatePlaceholdersIndexes';

export const revertAll = createAction('revertAll');

const store = configureStore({
  reducer: {
    companies: companiesReducer,
    categories: categoriesReducer,
    user: userReducer,
    documents: documentsReducer,
    userSigningInfo: userSigningInfoReducer,
    documentContracts: documentContractsReducer,
    documentTemplates: documentTemplatesReducer,
    employees: employeesReducer,
    suppliers: suppliersReducer,
    customers: customersReducer,
    todos: todoReducer,
    businessProfile: businessProfileSlice,
    disclaimerInfo: disclaimerSlice,
    countriesInfo: countriesSlice,
    documentUploadHTML: documentUploadHTMLSlice,
    currentDocumentAISummary: currentDocumentAISummarySlice,
    showPlanUpgradingMessage: showPlanUpgradingMessageSlice,
    showProgressOverlay: showProgressOverlaySlice,
    templates: templatesSlice,
    documentsAnotherUser: documentsAnotherUserSlice,
    documentContractsAnotherUser: documentContractsAnotherUserSlice,
    supplierBankDetails: supplierBankDetailsReducer,
    tasks: tasksSlice,
    templatePlaceholdersIds: templatePlaceholdersIdsSlice,
    templatePlaceholdersIndexes: templatePlaceholdersIndexesSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
